import React from 'react';
import { getIdFromYoutubeLink } from 'helpers';
import { styled } from '@teko/ui';

interface YoutubeFrameProps {
  embedId?: string;
  youtubeLink?: string;
  openInPopup?: boolean;
}

const StyledIframe = styled.iframe<{ openInPopup: boolean }>(
  ({ openInPopup }) => `
    position: relative;
    height: 100%;
    width: 100%;
    pointer-events: ${openInPopup ? 'none' : 'auto'};
`,
);

export const YoutubeFrame: React.FC<YoutubeFrameProps> = ({
  embedId,
  youtubeLink,
  openInPopup = false,
}: YoutubeFrameProps) => {
  const videoEmbedId = youtubeLink
    ? getIdFromYoutubeLink(youtubeLink)
    : embedId;
  if (!videoEmbedId) return null;
  return (
    <StyledIframe
      src={`https://www.youtube.com/embed/${videoEmbedId}`}
      allowFullScreen
      frameBorder="0"
      openInPopup={openInPopup}
    />
  );
};
